import React from 'react'
import { Box, Collapse } from '@mui/material'
import { HistoryItem as HistoryItemType, ViewMode, AccountType } from '../types'
import HistoryItemHeader from './HistoryItemHeader'
import HistoryItemDiff from './HistoryItemDiff'
import HistoryItemAccounts from './HistoryItemAccounts'

interface HistoryItemProps {
  item: HistoryItemType
  isExpanded: boolean
  viewMode: ViewMode
  onToggle: () => void
}

const HistoryItem: React.FC<HistoryItemProps> = ({ 
  item, 
  isExpanded, 
  viewMode, 
  onToggle 
}) => {
  const accountTypes: AccountType[] = ['added_accounts', 'removed_accounts']
  const availableTypes = accountTypes.filter(type => item.context?.[type]?.length > 0)
  const filteredDiffs = item.diff ? item.diff.filter(d => d.attribute !== 'updated_at') : []

  return (
    <Box sx={{ pb: 4 }}>
      <HistoryItemHeader 
        item={item} 
        isExpanded={isExpanded} 
        viewMode={viewMode} 
        onToggle={onToggle} 
      />

      <Collapse in={isExpanded} timeout={300}>
        <Box sx={{ pl: .5, pt: 1 }}>
          {filteredDiffs.length > 0 && (
            <Box>
              {filteredDiffs.map((diff, idx, arr) => {
                const isLast = idx === arr.length - 1 && availableTypes.length === 0
                
                return (
                  <HistoryItemDiff
                    key={idx}
                    diff={diff}
                    action={item.action}
                    routingKey={item.routing_key}
                    isLast={isLast}
                  />
                )
              })}
            </Box>
          )}

          {availableTypes.map((type, index) => (
            <HistoryItemAccounts
              key={type}
              item={item}
              accountType={type}
              isLast={index === availableTypes.length - 1}
            />
          ))}
        </Box>
      </Collapse>
    </Box>
  )
}

export default HistoryItem
